import ReactDOM from "react-dom";
import React, { PureComponent } from "react";
import QuestionItems from './questionitems';

class Question extends PureComponent {

    render() {
        const { name, text, items } = this.props;
        window.scroll(0, 0);
   

        return (
            <div className='question'>
                <h2>{name}</h2>
                <div dangerouslySetInnerHTML={{ __html: text }} />
                <QuestionItems items={items} />
            </div>
        );
    }
}

export default Question;